/** Shared step sizes for keyboard shortcuts (formerly touch rails). */
export const SHORTCUT_DELAY_STEP_MS = 100;
export const SHORTCUT_FONT_STEP = 0.05;
export const SHORTCUT_FONT_MIN = 0.4;
export const SHORTCUT_FONT_MAX = 2.5;
/** Pixel nudge matching extension layout tests (~one visual step). */
export const SHORTCUT_SUB_Y_NUDGE_PX = 54;
